
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gdpr-policy",
      function () {
        return require("private-next-pages/gdpr-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gdpr-policy"])
      });
    }
  